module.exports = __webpack_public_path__ + "img/full3-min.89333c32.png";